// extracted by mini-css-extract-plugin
module.exports = {"transactionRow":"TransactionRow_transactionRow__1PXL-","left":"TransactionRow_left__2wlSI","right":"TransactionRow_right__3TqPs"};